import { render, staticRenderFns } from "./BusquedaAvanzada.vue?vue&type=template&id=2d2525f8"
import script from "./BusquedaAvanzada.vue?vue&type=script&lang=js"
export * from "./BusquedaAvanzada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports